let load = require('./helpers/browser/esm-js-loader');
module.exports = Promise.all([load("ffQaD"), load("kvRbA"), load("7w8Lg")]).then(() => parcelRequire('6Tw9l'));